module.exports = __webpack_public_path__ + "e3e21b6c3741deb62bd423445c377bef.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/retribution-video-poster.jpg
// module id = 524
// module chunks = 0